import { render } from "./AgreementManagement.vue?vue&type=template&id=5afbaf6b&scoped=true"
import script from "./AgreementManagement.vue?vue&type=script&lang=js"
export * from "./AgreementManagement.vue?vue&type=script&lang=js"

import "./AgreementManagement.vue?vue&type=style&index=0&id=5afbaf6b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5afbaf6b"]])

export default __exports__